import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './item-summary.module.scss';
import { isValidArray } from '../../../../utilities/validations';

function ItemSummary(props) {
	const [summaryOpen, setSummaryOpen] = useState('');

	useEffect(() => {
		if (summaryOpen === '') {
			setSummaryOpen(props.defaultOpen);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps -- preexisting failure, fix when possible
	}, []);

	const toggleSummary = () => {
		if (summaryOpen === true) {
			setSummaryOpen(false);
		} else {
			setSummaryOpen(true);
		}
	};

	return (
		isValidArray(props?.questionsAnswers) && (
			<div className={`${styles.itemSummary_container} ${styles[`itemSummary_${props.context}`]}`}>
				<button
					type='button'
					aria-expanded={summaryOpen}
					onClick={() => toggleSummary()}
					className={`${styles.itemSummary_summaryButton} ${summaryOpen ? styles.itemSummary_summaryButton_active : ''}`}
				>
					<svg
						width='22px'
						height='12px'
						viewBox='0 0 29 19'
					>
						<g transform='translate(-6, -11)'>
							<polygon
								transform='translate(20.5, 20.5) rotate(90) translate(-20.5, -20.5) '
								points='11 9.074 23.3531353 20.5 11 31.926 14.3234323 35 30 20.5 14.3234323 6'
							></polygon>
						</g>
					</svg>
					{props.detailsHeading}
				</button>
				<div className={`${styles.itemSummary_values} ${summaryOpen ? styles.itemSummary_open : ''}`}>
					{props.questionsAnswers.map((qa, index) => {
						if (qa.question_text === 'Part Number') {
							return (
								<div key={index}>
									<p className={styles.itemSummary_specificationHeading}>{qa?.question_text}: </p>
									<p className={styles.itemSummary_specificationValue}>{qa?.selected_answer_id}</p>
								</div>
							);
						}
						if (qa.question_text === 'Select Part') {
							return (
								<div key={index}>
									<p className={styles.itemSummary_specificationHeading}>Part Number: </p>
									<p className={styles.itemSummary_specificationValue}>{props.partNumber}</p>
								</div>
							);
						}
						if (qa.answers.length >= 1 && qa.question_text !== 'Description') {
							return (
								<div key={index}>
									<p className={styles.itemSummary_specificationHeading}>{qa?.question_text}: </p>
									<p className={styles.itemSummary_specificationValue}>{qa?.answers?.find(({ id }) => id === qa?.selected_answer_id)?.text}</p>
								</div>
							);
						}
					})}
				</div>
			</div>
		)
	);
}

ItemSummary.propTypes = {
	context: PropTypes.string,
	defaultOpen: PropTypes.bool,
	questionsAnswers: PropTypes.array,
	detailsHeading: PropTypes.string,
	partNumber: PropTypes.string,
};

export default ItemSummary;
